import {useLayoutEffect, useRef} from "react";

class NoWindowScroll {
    constructor() {
        this.counter = 0;
        this.top = 0;
    }
    on() {
        if (this.counter === 0) {
            this.top = window.scrollY;
            // document.body.style.top = `-${window.scrollY}px`;
            // document.body.style.position = 'fixed';
            document.body.style.height = "100%";
            document.body.style.overflow = "hidden";
        }
        this.counter += 1;
    }
    off() {
        this.counter -= 1;
        if (this.counter === 0) {
            // document.body.style.position = '';
            // document.body.style.top = '';
            document.body.style.height = "";
            document.body.style.overflow = "";
            window.scrollTo(0, this.top);
            this.top = 0;
        }
    }
}

const noWindowScroll = new NoWindowScroll();

export function useNoWindowScroll(when) {
    const valueRef = useRef(false);
    useLayoutEffect(() => {
        if (valueRef.current !== when) {
            valueRef.current = when;
            if (when) {
                noWindowScroll.on();
            } else {
                noWindowScroll.off();
            }
        }
        return () => {
            if (valueRef.current) {
                valueRef.current = false;
                noWindowScroll.off();
            }
        }
    }, [when])
}
